// import React, { useState, createContext } from "react";

const DietDays = [    
    {
        name: "5 posiłków",
        id: 1,
    },
    {
        name: "3 wybrane posiłki z wybranej kaloryczności",
        id: 2,
    }
    // {
    //     name: "zestaw testowy",
    //     id: 3,
    // }
]

export default DietDays